import { useTranslation } from "next-i18next";

import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import { ProductDetailsSellerLabel } from "@/components/ProductDetail/ProductDetailsSellerLabel";
import useMerchant from "@/hooks/useMerchant";
import { Heading } from "@/ui/cva/Heading";

type ProductDetailsInfoSellerTitleProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetailsInfoSellerTitle = ({
  product,
}: ProductDetailsInfoSellerTitleProps) => {
  const { t } = useTranslation();
  const { id: userId } = useMerchant();

  const isProductOwner = product.merchant.id === userId;
  const merchant = product.merchant;

  return (
    <div className="flex w-full flex-wrap items-center">
      <Heading as="h5" className="mr-2">
        {t("pdp:pdp-seller-block-title")}
      </Heading>
      <ProductDetailsSellerLabel
        sellerIsOwner={isProductOwner}
        merchantType={merchant.type}
        className="whitespace-nowrap rounded"
      />
    </div>
  );
};
